/**
 * Global valuation types for the unified valuations journey.
 *
 * - instant: algorithm-driven instant estimate (redirects to /valuation)
 * - expert: specialist/sales valuation (a.k.a. expert valuation)
 * - replacement: replacement/insurance valuation
 *
 * Used by the ValuationJourneyDrawer, SellArtworkHero (via the CMS
 * `valuationType` field on the valuationHero block) and the
 * /valuation-confirmation page. Extend here if new valuation products are
 * added later.
 */
export enum ValuationTypes {
  instant = 'instant',
  expert = 'expert',
  replacement = 'replacement',
}

export const isValuationType = (value: unknown): value is ValuationTypes =>
  typeof value === 'string' &&
  (Object.values(ValuationTypes) as string[]).includes(value)
